import { Component } from '@angular/core';

@Component({
  selector: 'security-info',
  template: require('./security-info.component.html'),
  host: { class: 'flex-column min-height-full-vh-bg-color' },
  // host: { class: 'flex-column min-height-full-vh' },
})
export class SecurityInfoComponent {}